import React from 'react';
import {ComponentHistoryTreeViewerProps} from '../../../../@types/editor-props';
import ComponentFaultTreeCanvas from './ComponentFaultTreeCanvas';

/**
 * A Component's fault tree as it was at one history entry, opened from the History tab. Always
 * read-only: going back to it is a Restore, which records a new entry.
 */
export default function ComponentHistoryTreeViewer(props: ComponentHistoryTreeViewerProps): React.ReactElement {
    const {componentVersion, isActive, updateTab} = props;

    return (
        <ComponentFaultTreeCanvas
            component={componentVersion.component}
            isActive={isActive}
            readonly={true}
            snapshot={true}
            updateTab={updateTab}
        />
    );
}
